import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IntegrationUsersService = {
    list: async () => axios.get( API_KEEPER + "/integration-users/list").then(({ data }) => data).catch((err) => { throw err }),

    getUser: async (id) => axios.get(API_KEEPER + `/integration-users/get/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    getInfo: async () => axios.get(API_KEEPER + "/user/get-info").then(({ data }) => data).catch((err) => { throw err }),

    genToken: async (userId) => axios.post(API_KEEPER + "/generateTokenToUser", {userId}).then(({ data }) => data).catch((err) => { throw err }),

    save: async (formData) => axios.post(API_KEEPER + "/integration-users", formData).then(({ data }) => data).catch((err) => { throw err }),
};

export default IntegrationUsersService;